import { useSyncExternalStore } from 'react';
import { matchMedia } from '@/lib/isomorphic';

export function useBreakpoint(
  breakpoint: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
): boolean {
  const getSnapshot = () => {
    if (typeof document === 'undefined') return false;
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(`--breakpoint-${breakpoint}`)
      .trim();
    if (!value) return false;
    return matchMedia(`(min-width: ${value})`);
  };

  const subscribe = (callback: () => void) => {
    if (typeof window === 'undefined') return () => {};
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(`--breakpoint-${breakpoint}`)
      .trim();
    if (!value) return () => {};
    const media = window.matchMedia(`(min-width: ${value})`);
    media.addEventListener('change', callback);
    return () => media.removeEventListener('change', callback);
  };

  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
